import { useModal } from '@shared/model/useModal';

export const useUpdateAvatarModal = () => useModal('update-avatar')